import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import api from '../services/api';
import './Login.css';

// Toggle para Login Social Google (Pré-pronto para expansão SaaS multi-tenant)
const ENABLE_GOOGLE_LOGIN = process.env.REACT_APP_ENABLE_GOOGLE_LOGIN === 'true';

function Login({ onLogin, onBackToSite }) {
  const [form, setForm] = useState({ usuario: '', senha: '' });
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const googleBtnRef = useRef(null);

  const handleGoogleSuccess = async (googleResponse) => {
    setErro('');
    setGoogleLoading(true);
    try {
      const response = await api.post('/auth/google', {
        credential: googleResponse.credential,
      });

      const { token, usuario, login } = response.data;
      localStorage.setItem('erp_token', token);
      localStorage.setItem('erp_usuario', usuario);
      localStorage.setItem('erp_login', login || usuario);
      axios.defaults.headers.common.Authorization = `Bearer ${token}`;
      api.defaults.headers.common.Authorization = `Bearer ${token}`;

      onLogin(usuario);
    } catch (error) {
      const msg =
        error.response?.data?.error ||
        error.response?.data?.message ||
        'Não foi possível conectar com a conta Google. Tente novamente.';
      setErro(msg);
    } finally {
      setGoogleLoading(false);
    }
  };

  useEffect(() => {
    if (!ENABLE_GOOGLE_LOGIN) return;

    const initGoogle = async () => {
      try {
        const res = await api.get('/auth/google/client-id');
        const clientId = res.data?.clientId || process.env.REACT_APP_GOOGLE_CLIENT_ID;

        if (window.google?.accounts?.id) {
          window.google.accounts.id.initialize({
            client_id: clientId || '1041928374-placeholder.apps.googleusercontent.com',
            callback: handleGoogleSuccess,
            auto_select: false,
            cancel_on_tap_outside: true,
          });

          if (googleBtnRef.current && clientId) {
            window.google.accounts.id.renderButton(googleBtnRef.current, {
              theme: 'outline',
              size: 'large',
              width: 340,
              text: 'continue_with',
              shape: 'pill',
              locale: 'pt-BR',
            });
          }
        }
      } catch (_) {}
    };

    // Tentar inicializar quando o script do Google carregar
    if (window.google?.accounts?.id) {
      initGoogle();
    } else {
      const interval = setInterval(() => {
        if (window.google?.accounts?.id) {
          clearInterval(interval);
          initGoogle();
        }
      }, 500);
      return () => clearInterval(interval);
    }
  }, []);

  const handleGoogleCustomClick = () => {
    setErro('');
    if (window.google?.accounts?.id) {
      window.google.accounts.id.prompt((notification) => {
        if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
          // Se o prompt nativo não for exibido (ex: sem client id configurado ainda)
        }
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    setLoading(true);

    try {
      const response = await api.post('/auth/login', form);
      const { token, usuario, login } = response.data;

      localStorage.setItem('erp_token', token);
      localStorage.setItem('erp_usuario', usuario);
      localStorage.setItem('erp_login', login || usuario);
      axios.defaults.headers.common.Authorization = `Bearer ${token}`;
      api.defaults.headers.common.Authorization = `Bearer ${token}`;

      onLogin(usuario);
    } catch (error) {
      const msg =
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message ||
        'Não foi possível realizar o login. Tente novamente.';
      setErro(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        {onBackToSite && (
          <button type="button" onClick={onBackToSite} className="login-back-btn">
            ← Voltar ao Site da Fran
          </button>
        )}

        <div className="login-logo">
          <span className="login-emoji">✨</span>
          <h1>ERP Fran Beauty</h1>
          <p className="login-subtext">Acesso ao Painel de Gestão</p>
        </div>

        {/* ── Botão Oficial de Login com Google (Pré-pronto para SaaS) ── */}
        {ENABLE_GOOGLE_LOGIN && (
          <div className="login-google-section">
            <div ref={googleBtnRef} className="google-official-btn-slot"></div>
            
            <button
              type="button"
              className="login-google-btn"
              onClick={handleGoogleCustomClick}
              disabled={googleLoading}
            >
              <svg className="google-svg-icon" viewBox="0 0 24 24">
                <path
                  fill="#4285F4"
                  d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                />
                <path
                  fill="#34A853"
                  d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                />
                <path
                  fill="#FBBC05"
                  d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l2.85-2.22.81-.63z"
                />
                <path
                  fill="#EA4335"
                  d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z"
                />
              </svg>
              <span>{googleLoading ? 'Conectando com o Google...' : 'Entrar com a conta Google'}</span>
            </button>

            <div className="login-divider">
              <span>ou entre com login e senha</span>
            </div>
          </div>
        )}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="login-field">
            <label>E-mail ou Usuário</label>
            <input
              type="text"
              autoComplete="username"
              value={form.usuario}
              onChange={(e) => setForm({ ...form, usuario: e.target.value })}
              placeholder="ex: fran@franbeauty.com.br ou fran"
              required
              disabled={loading || googleLoading}
            />
          </div>

          <div className="login-field">
            <label>Senha</label>
            <div className="login-pass-row">
              <input
                type={showPass ? 'text' : 'password'}
                autoComplete="current-password"
                value={form.senha}
                onChange={(e) => setForm({ ...form, senha: e.target.value })}
                placeholder="Digite sua senha"
                required
                disabled={loading || googleLoading}
              />
              <button
                type="button"
                className="login-show-pass"
                onClick={() => setShowPass((prev) => !prev)}
                tabIndex={-1}
              >
                {showPass ? '🙈' : '👁️'}
              </button>
            </div>
          </div>

          {erro && <div className="login-erro">{erro}</div>}

          <button type="submit" className="login-btn" disabled={loading || googleLoading}>
            {loading ? 'Entrando...' : 'Entrar no Sistema'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
